import {
  CustomSearch,
  CustomSearchProps,
} from "@tuteria/shared-lib/src/_new_/features/custom-search/CustomSearch";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";

// export function unMountCustomSearchModal(id: string) {
//   ReactDOM.unmountComponentAtNode(document.getElementById(id));
// }

type Props = {
  getFilters: CustomSearchProps["getFilters"];
};

const Component = ({ getFilters }: Props) => {
  return (
    <CustomSearch
      getFilters={getFilters}
      baseUrl={window.location.origin + window.location.pathname}
      // onClose={onClose}
    />
  );
};

// type Payload = {
//   title: string;
// };

export function customSearch(
  // payload: Payload,
  id: string,
  urls: {},
  callback: (...args: any[]) => void
) {
  //   function onClose() {
  //     unMountCustomSearchModal(id);
  //   }

  let SHEET_API = "https://sheet.tuteria.com";

  async function getFiltersFromSheet() {
    let response = await fetch(`${SHEET_API}/read-single`, {
      method: "POST",
      body: JSON.stringify({
        link: "https://docs.google.com/spreadsheets/d/1BBI6HUCpHkHk_AgxBEGACpL90dV_D4mySG3-c0ewGVY/edit?usp=sharing",
        sheet: "custom_search_params",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      let result = await response.json();
      return [result.data, null];
    }

    return [null, "An error occurred"];
  }

  const formatFilter = (filter: any) => {
    const newFilter = filter;

    newFilter.options = filter.options ? JSON.parse(filter.options) : null;
    newFilter.multipleSelect = Boolean(filter.multipleSelect);
    newFilter.searchable = Boolean(filter.searchable);

    return newFilter;
  };

  const formatFilterLabel = (label: string) => {
    // active_booking_range and previous_booking_range from the url will not match any of the filter's label unless we format it.
    let formattedLabel = label;
    if (label.includes("_booking")) {
      const labelDes = label.split("_");
      formattedLabel = `${labelDes[0]}_booking`;
    }

    return formattedLabel;
  };

  const formatFilterValue = (label: string, value: string) => {
    // 0,3_range
    let formattedValue = value;
    if (label.includes("_booking")) {
      const labelDes = label.split("_");
      formattedValue = `${value}_${labelDes[labelDes.length - 1]}`;
    }

    return formattedValue.replaceAll(/\+/g, " ");
  };

  const getFilters = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const [res, error] = await getFiltersFromSheet();
        const filters = res.map((filter) => formatFilter(filter));

        const searchQuery = decodeURIComponent(window.location.search);
        const queryFiltersStr = searchQuery.split("q=")[1];
        let existingFilters = [];
        if (queryFiltersStr) {
          const queryFilters = queryFiltersStr.split("$$");
          existingFilters = queryFilters
            .map((filter) => {
              const filterArr = filter.split(":");

              const filterVal = filters.find((_filter) => {
                const label = formatFilterLabel(filterArr[0]);
                if (_filter.value.toLowerCase() === label.toLowerCase())
                  return _filter;
              });
              if (filterVal) {
                let inputValue: string | string[] = formatFilterValue(
                  filterArr[0],
                  filterArr[1]
                );
                return { ...filterVal, inputValue };
              }
              return null;
            })
            .filter((val) => val);
        }

        if (res) {
          return resolve({ filters, existingFilters });
        }

        return reject(error);
      } catch (e) {
        return reject(e);
      }
    });
  };

  ReactDOM.render(
    <ThemeProvider>
      <Component
        {...{
          getFilters,
        }}
      />
    </ThemeProvider>,
    document.getElementById(id)
  );
}
